var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.photos
    ? _c(
        "div",
        {
          ref: "carouselContainer",
          staticClass: "slider carousel-container",
          on: {
            touchstart: _vm.onTouchStart,
            touchmove: _vm.onTouchMove,
            touchend: _vm.onTouchEnd
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "carousel-track",
              style: {
                transform: "translateX(-" + _vm.currentPhotoSlide * 100 + "%)"
              }
            },
            _vm._l(_vm.photos, function(photo, index) {
              return _c("div", { key: index, staticClass: "carousel-slide" }, [
                _c("img", {
                  staticClass: "carousel-img",
                  attrs: { src: photo.image_url, alt: "photo" }
                })
              ])
            }),
            0
          ),
          _vm._v(" "),
          _vm.photos && _vm.photos.length > 1
            ? _c(
                "div",
                { staticClass: "carousel-dots" },
                _vm._l(Math.min(_vm.photos.length, 5), function(n) {
                  return _c("span", {
                    key: n - 1,
                    staticClass: "dot",
                    class: _vm.getPhotoDotClasses(n - 1),
                    on: {
                      click: function($event) {
                        return _vm.goToPhotoDotSlide(n - 1)
                      }
                    }
                  })
                }),
                0
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d31dcf98", { render: render, staticRenderFns: staticRenderFns })
  }
}